<template>
  <div
    class="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 px-6 py-4"
    :class="props.class"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  class?: string
}

const props = defineProps<Props>()
</script>
